const { default: messages } = require("./messages");



function getLanguageOnLocalstorage() {
    const language = localStorage.getItem('language')    
    const null_langueges = ['null', 'undefined', '']    
    if (null_langueges.includes(language)) {    
        const portugueseCode = 1    
        return  portugueseCode    
    }
    return language
}
function displayMessage(index, params = []) {
    try {
        const br_code = 1
        const language = getLanguageOnLocalstorage() || br_code
        if (!index) {
            console.log("Missing index");
            return '-';
        }

        const messageSet = messages[index];
        if (!messageSet) {
            console.log("Missing message index:", index);
            return '-';
        }

        let message = messageSet[language];
        if (!message) {
            console.log(`Missing language (${language}) for index ${index}`);
            return '-';
        }

        if (!message) {
            return '-'
        }

        if (typeof params == 'object' && params != null && params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                const param = params[i];
                // const re = new RegExp(`/{${i}}/`, 'g')
                // message = message.replace(re, param)
                message = message.split(`{${i}}`).join(param)
            }
        }
        return message
    } catch (error) {
        console.log(error)
        return '-'
    }
}


module.exports = {getLanguageOnLocalstorage, displayMessage}